// extracted by mini-css-extract-plugin
export default {"cont":"UserImage_cont__ff9dS","parent":"UserImage_parent__iVpj5","user-image":"UserImage_user-image__dgluQ","child":"UserImage_child__xuHGe"};